// Ported from vlookup-dramatic/app/about/reveal.tsx by scripts/revamp/port-design.js
import React, { useEffect, useRef } from "react";
import { cn } from "../../lib/utils";
/**
 * Lightweight scroll-reveal wrapper (About page only).
 * The hidden initial state is applied via CSS `@media (scripting: enabled)`
 * in the page's <style> tag, so content stays visible without JS and when
 * the user prefers reduced motion.
 */
export function Reveal({ children, className, delay = 0, }) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            el.setAttribute("data-revealed", "");
            return;
        }
        const io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    el.setAttribute("data-revealed", "");
                    io.disconnect();
                }
            }
        }, { threshold: 0.15, rootMargin: "0px 0px -48px 0px" });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return (<div ref={ref} data-about-reveal className={cn(className)} style={delay ? { transitionDelay: `${delay}ms` } : undefined}>
      {children}
    </div>);
}
